import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Dropdown, DropdownCallout } from "azure-devops-ui/Dropdown";
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { GroupedItemProvider } from "azure-devops-ui/Utilities/GroupedItemProvider";
import { IListBoxItem, LoadingCell, ListBoxItemType } from "azure-devops-ui/ListBox";
import { ITableColumn } from "azure-devops-ui/Table";
import { Location } from "azure-devops-ui/Utilities/Position";
import "./Dropdown.css";

export default class DropdownAdvancedExample extends React.Component {
    private loading = new ObservableValue<boolean>(false);
    private selection = new DropdownSelection();
    private loadingItem: IListBoxItem = {
        id: "loading",
        type: ListBoxItemType.Loading,
        render: (
            rowIndex: number,
            columnIndex: number,
            tableColumn: ITableColumn<IListBoxItem<{}>>,
            tableItem: IListBoxItem<{}>
        ) => {
            return (
                <LoadingCell
                    key={rowIndex}
                    columnIndex={columnIndex}
                    tableColumn={tableColumn}
                    tableItem={tableItem}
                    onMount={this.onLoadingMount}
                />
            );
        }
    };
    private itemProvider = new GroupedItemProvider([this.loadingItem], [], true);

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <Dropdown
                    ariaLabel="Loading"
                    items={this.itemProvider}
                    loading={this.loading}
                    placeholder="Select an Option"
                    selection={this.selection}
                    className="example-dropdown"
                    width={250}
                    renderCallout={props => (
                        <DropdownCallout
                            {...props}
                            dropdownOrigin={{
                                horizontal: Location.start,
                                vertical: Location.start
                            }}
                            anchorOrigin={{
                                horizontal: Location.start,
                                vertical: Location.end
                            }}
                        />
                    )}
                />
            </div>
        );
    }

    private onLoadingMount = () => {
        if (!this.loading.value) {
            // Set loading to true once we start fetching items, this will announce
            // that loading has begun to screen readers.
            this.loading.value = true;
            window.setTimeout(() => {
                //remove the loading item
                this.itemProvider.pop();

                // Add groups and items
                for (let i = 1; i <= 5; i++) {
                    const groupId = i.toString();
                    this.itemProvider.pushGroups({
                        id: groupId,
                        name: "Group " + i
                    });
                    for (let j = 0; j < 10; j++) {
                        this.itemProvider.push({
                            id: i + "-" + j,
                            text: "item " + ((i - 1) * 10 + j),
                            groupId: i.toString()
                        });
                    }
                }

                // Set loading to false to announce how many items have loaded to screen readers.
                this.loading.value = false;

                // Select the first item.
                this.selection.select(1);
            }, 1000);
        }
    };
}
